import { Permission } from "~/typings/enums";
import _ from "lodash";

const permissionTranslations: Record<Permission, string> = {
    [Permission.Global_CaregroupManagement_AssignPatients]: 'Koppel patiënt',
    [Permission.Global_CaregroupManagement_Create]: 'Aanmaken',
    [Permission.Global_CaregroupManagement_CreateDepartment]: 'Afdeling aanmaken',
    [Permission.Global_CaregroupManagement_ManageModules]: 'Modules beheren',
    [Permission.Global_CaregroupManagement_ManagePreferences]: 'Voorkeuren beheren',
    [Permission.Global_CaregroupManagement_Overview]: 'Overzicht',
    [Permission.Global_CaregroupManagement_SwitchCaregroups]: 'Zorggroep wisselen',
    [Permission.Global_CaregroupManagement_UpdateInfo]: 'Bijwerken',
    [Permission.Global_CaregroupManagement_View]: 'Bekijken',
    [Permission.Global_CaregroupManagement_ViewAny]: 'Alle zorggroepen bekijken',
    [Permission.Global_PatientManagement_Create]: 'Aanmaken',
    [Permission.Global_PatientManagement_Overview]: 'Overzicht',
    [Permission.Global_PatientManagement_UpdateMedicalRecord]: 'Medische gegevens wijzigen',
    [Permission.Global_UserManagement_AssignToCaregroup]: 'Aan zorggroep koppelen',
    [Permission.Global_UserManagement_AuthorizeUsers]: 'Autoriseren',
    [Permission.Global_UserManagement_ChangeEmail]: 'E-mail wijzigen',
    [Permission.Global_UserManagement_ChangePhone]: 'Telefoonnummer wijzigen',
    [Permission.Global_UserManagement_ChangeStatus]: 'Status wijzigen',
    [Permission.Global_UserManagement_Create]: 'Aanmaken',
    [Permission.Global_UserManagement_EditContactInfo]: 'Bijwerken',
    [Permission.Global_UserManagement_Manage2FA]: '2FA beheren',
    [Permission.Global_UserManagement_Overview]: 'Overzicht',
    [Permission.Global_UserManagement_ResetPassword]: 'Wachtwoord opnieuw instellen',
    [Permission.Global_UserManagement_ValidateBig]: 'Big-nummer valideren',
    [Permission.Global_StatusAnnouncements_Manage]: 'Beheren',
    [Permission.Global_StatusAnnouncements_View]: 'Bekijken',
    [Permission.Module_TrackingSystem_Barcodes_Move]: 'Verplaatsen',
    [Permission.Module_TrackingSystem_Barcodes_View]: 'Bekijken',
    [Permission.Module_TrackingSystem_Global_Manage]: 'Beheren',
    [Permission.Module_TrackingSystem_Global_View]: 'Bekijken',
    [Permission.Module_TrackingSystem_Invoices_Download]: 'Downloaden',
    [Permission.Module_TrackingSystem_Invoices_View]: 'Bekijken',
    [Permission.Module_TrackingSystem_Invoices_ViewAll]: 'Overzicht',
    [Permission.Module_TrackingSystem_Locations_Create]: 'Aanmaken',
    [Permission.Module_TrackingSystem_Locations_Delete]: 'Verwijderen',
    [Permission.Module_TrackingSystem_Locations_Edit]: 'Bijwerken',
    [Permission.Module_TrackingSystem_Locations_View]: 'Bekijken',
    [Permission.Module_TrackingSystem_Locations_ViewAll]: 'Overzicht',
    [Permission.Module_TrackingSystem_Orders_Create]: 'Aanmaken',
    [Permission.Module_TrackingSystem_Orders_Edit]: 'Bijwerken',
    [Permission.Module_TrackingSystem_Orders_View]: 'Bekijken',
    [Permission.Module_TrackingSystem_Orders_View_Price]: 'Prijzen inzien',
    [Permission.Module_TrackingSystem_Orders_ViewAll]: 'Overzicht',
    [Permission.Module_TrackingSystem_Stock_Delete]: 'Verwijderen',
    [Permission.Module_TrackingSystem_Stock_Edit]: 'Bijwerken',
    [Permission.Module_TrackingSystem_Stock_View]: 'Bekijken',
    [Permission.Portal_CounterReading_Edit]: 'Wijzigen',
    [Permission.Portal_CounterReading_Insert]: 'Toevoegen',
    [Permission.Portal_CounterReading_Manage]: 'Beheren',
    [Permission.Portal_CounterReading_View]: 'Bekijken',
    [Permission.Portal_Orders_AddNewProducts]: 'Nieuw product toevoegen',
    [Permission.Portal_Orders_Edit]: 'Wijzigen',
    [Permission.Portal_Orders_Overview]: 'Overzicht',
    [Permission.Therapy_Be_Validate]: 'Valideren',
    [Permission.Therapy_Be_View]: 'Bekijken',
    [Permission.Therapy_Cf_Validate]: 'Valideren',
    [Permission.Therapy_Cf_View]: 'Bekijken',
    [Permission.Therapy_ClusterHeadache_Validate]: 'Valideren',
    [Permission.Therapy_ClusterHeadache_View]: 'Bekijken',
    [Permission.Therapy_NasalHighFlow_View]: 'Bekijken',
    [Permission.Therapy_NebulizationWithAntibiotics_Validate]: 'Valideren',
    [Permission.Therapy_NebulizationWithAntibiotics_View]: 'Bekijken',
    [Permission.Therapy_NebulizationWithOutAntibiotics_View]: 'Bekijken',
    [Permission.Therapy_Oxygen_Validate]: 'Valideren',
    [Permission.Therapy_Oxygen_View]: 'Bekijken',
    [Permission.Therapy_Pap_CreateApprovalConcepts]: 'Concept akkoordverklaring maken',
    [Permission.Therapy_Pap_ValidateApproval]: 'Akkoordverklaring valideren',
    [Permission.Therapy_Pap_View]: 'Bekijken',
    [Permission.Therapy_Pep_View]: 'Bekijken',
    [Permission.Therapy_Spt_CreateApprovalConcepts]: 'Concept akkoordverklaring maken',
    [Permission.Therapy_Spt_ValidateApproval]: 'Akkoordverklaring valideren',
    [Permission.Therapy_Spt_View]: 'Bekijken',
    [Permission.TherapyGlobal_Concepts_Delete]: 'Verwijderen',
    [Permission.TherapyGlobal_Concepts_Edit]: 'Aanpassen',
    [Permission.TherapyGlobal_Concepts_Submit]: 'Indienen',
    [Permission.TherapyGlobal_Overview_View]: 'Bekijken',
    [Permission.TherapyGlobal_WithBigMentions_Approve]: 'Goedkeuren therapie-aanvragen',
}

const generalTranslations = {
    "global.title": "Algemeen",
    "global.caregroup-management.title": "Zorggroep beheer",
    "global.user-management.title": "Gebruiker beheer",
    "global.patient-management.title": "Patient beheer",
    "global.status-announcements.title": "Statusmeldingen",
    "therapy-global.title": "Therapie globaal",
    "therapy-global.concepts.title": "Conceptaanvragen",
    "therapy-global.overview.title": "Overzicht",
    "therapy-global.with-big-mentions.title": "BIG Bevoegdheden",
    "therapy.title": "Therapie",
    "therapy.oxygen.title": "Zuurstof aanvragen",
    "therapy.nasal-high-flow.title": "Nasal High Flow",
    "therapy.nebulization-with-antibiotics.title": "Verneveling met antibiotica",
    "therapy.nebulization-without-antibiotics.title": "Verneveling zonder antibiotica",
    "therapy.cluster-headache.title": "Clusterhoofdpijn",
    "therapy.bronchiectasis.title": "Bronchiëctasieën (BE) / antibiotica",
    "therapy.positive-expiratory-pressure.title": "Positive Expiratory Pressure (PEP)",
    "therapy.cystic-fibrosis.title": "Cystic Fibrosis (CF) / antibiotica",
    "therapy.positive-airway-pressure.title": "Positive Airway Pressure (PAP) Slaapapneu",
    "therapy.position-therapy.title": "Positietherapie (SPT)",
    "portal.title": "Portaal",
    "portal.counter-reading.title": "Tellerstanden",
    "portal.orders.title": "Bestellingen",
    "module.tracking-system.title": "Module - Zorgportaal",
    "module.tracking-system.global.title": "Algemeen",
    "module.tracking-system.barcodes.title": "Barcodes",
    "module.tracking-system.invoices.title": "Facturen",
    "module.tracking-system.locations.title": "Locaties",
    "module.tracking-system.orders.title": "Bestellingen",
    "module.tracking-system.stock.title": "Voorraad",
}

function getTranslations() {
    const result: Record<string, string> = {};
    const entries = Object.entries({
        ...permissionTranslations,
        ...generalTranslations,
    });

    entries.forEach(([key, value]) => _.set(result, key, value));

    return result;
}

export default {
    permissions: getTranslations(),
}
